<template>
  <div>
    <v-dialog v-model="dialogDoublon.model" width="500">
      <v-card>
          <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
          <v-card-text>
              <p>{{ dialogDoublon.texte }}</p>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialogDoublon.model = false">
                  {{ $storeUm6p.Label.Fermer }}
              </v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
    <small>
      Merci de saisir les frères et sœurs âgés de moins de 23 ans (nés après le {{DateAgeFratrieFormated}})
    </small>
    <v-layout row wrap xs12>
      <!-- debut dialog -->
      <v-dialog v-model="dialog" max-width="50%">
        <template v-slot:activator="{ on }">
          <v-layout class="btn-dialog" align-start justify-end>
            <v-btn
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              dark
              v-on="on"
              color="ecSecondary"
            >
              {{ $storeUm6p.Label.Ajouter }}
            </v-btn>
          </v-layout>
        </template>
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-toolbar color="ecSecondary" dark>
              <v-toolbar-title>{{ $storeUm6p.Label.Ajouter }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-col col="6">
                    <v-text-field
                      id="txt_nom"
                      v-model="$storeBourse.editedItem.nom"
                      :rules="$storeReglesBourse.obligatoire"
                      :label="$storeUm6p.Label.Fratrie.Nom"
                      class="asterisk"
                    />
                  </v-col>
                  <v-col col="6">
                    <v-text-field
                      v-model="$storeBourse.editedItem.prenom"
                      :rules="$storeReglesBourse.obligatoire"
                      :label="$storeUm6p.Label.Fratrie.Prenom"
                      class="asterisk"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="6">
                    <v-menu
                      v-model="menu.dateNaissance"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          clearable
                          v-model="DateNaissanceFormated"
                          :label="$storeUm6p.Label.Fratrie.DateNaissance"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="
                            $storeBourse.editedItem.dateNaissance = null
                          "
                          :rules="$storeReglesBourse.obligatoire"
                          class="asterisk"
                        />
                      </template>
                      <v-date-picker
                        v-model="$storeBourse.editedItem.dateNaissance"
                        :max="MaxDateNaissance"
                        :min="MinDateNaissance"
                        :rules="$storeReglesBourse.obligatoire"
                        @input="menu.dateNaissance = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col col="6"> </v-col>
                </v-row>
                <v-row>
                  <v-col col="6">
                    <v-autocomplete
                      :label="$storeUm6p.Label.Fratrie.SituationHandicap"
                      v-model="$storeBourse.editedItem.situationHandicap"
                      :item-text="$storeCommun.ItemLang"
                      item-value="id"
                      :items="$storeCatalogue.OuiNon"
                      clearable
                      class="asterisk"
                      :rules="$storeReglesBourse.obligatoire"
                      @change="SituationHandicapChange"
                    />
                  </v-col>
                  <v-col col="6">
                    <v-autocomplete
                      v-show="
                        $storeBourse.editedItem.situationHandicap ==
                        $storeCatalogue.DataId.Oui
                      "
                      :label="$storeUm6p.Label.Fratrie.TypeHandicap"
                      v-model="$storeBourse.editedItem.natureHandicap"
                      :item-text="$storeCommun.ItemLang"
                      item-value="id"
                      :items="$storeCatalogue.NatureHandicap"
                      :rules="
                        $storeBourse.editedItem.situationHandicap ==
                        $storeCatalogue.DataId.Oui
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                      clearable
                      class="asterisk"
                      multiple
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="6">
                    <v-text-field
                      :label="$storeUm6p.Label.Fratrie.NomPere"
                      v-model="$storeBourse.editedItem.nomPrenomPere"
                      class="asterisk"
                      :rules="$storeReglesBourse.obligatoire"
                    />
                  </v-col>
                  <v-col col="6">
                    <v-text-field
                      :label="$storeUm6p.Label.Fratrie.NomMere"
                      v-model="$storeBourse.editedItem.nomPrenomMere"
                      class="asterisk"
                      :rules="$storeReglesBourse.obligatoire"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small dark color="ecSecondary" @click="Close">{{
                $storeUm6p.Label.Annuler
              }}</v-btn>
              <v-btn small dark color="ecSecondary" @click="Save">{{
                $storeUm6p.Label.Valider
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- fin dialog -->
    </v-layout>
    <!-- Début Liste langues -->
    <v-data-table
      :headers="headers"
      :items="$storeBourse.DonneesFormulaireEC.listeFratrie"
      @current-items="ListeFratrie"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.supprimer">
          <th class="text-xs-left">{{ item.nom }}</th>
          <th class="text-xs-left">{{ item.prenom }}</th>
          <th class="text-xs-left">
            {{ $storeBourse.FormatDate(item.dateNaissance) }}
          </th>
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.OuiNon,
                item.situationHandicap,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th class="text-xs-left">
            {{
              item.situationHandicap == $storeCatalogue.DataId.Oui
                ? $storeCatalogue.AffichageCatalogueMultiple(
                    $storeCatalogue.NatureHandicap,
                    item.NatureHandicap,
                    $storeCommun.ItemLang
                  )
                : ""
            }}
          </th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="EditItem(item)"
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              >{{ icons.mdiPencil }}</v-icon
            >
            <v-icon
              small
              @click="DeleteItem(item)"
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
import { mdiPencil, mdiDelete } from "@mdi/js";
export default {
  components: {},
  data() {
    return {
      // menu date
      menu: {
        dateNaissance: false,
      },
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeBourse: this.$storeBourse,
      // dialog pour ouvrir/fermer la popup
      dialog: false,

      // Validation du formulaire
      valid: false,

      // nom des colonnes
      headers: [
        { text: "Nom", value: "nom" },
        { text: "Prenom", value: "prenom" },
        { text: "Date de naissance", value: "datenaissance" },
        { text: "En situation de handicap", value: "situationhandicap" },
        { text: "Type de handicap", value: "naturehandicap" },
        { text: "", value: "actions", sortable: false },
      ],
      blankItem: {
        index: null,
        idCrypte: null,
        supprimer: false,
        nom: null,
        prenom: null,
        dateNaissance: null,
        situationHandicap: null,
        natureHandicap: null,
        nomPrenomMere: null,
        nomPrenomPere: null,
        listeAnnexesFirsi: [],
      },
      // Dialog pour afficher un message de doublon
      dialogDoublon: {
          model: false,
          texte: "",
      },
    };
  },
  computed: {
    annee() {
      return moment(String(new Date())).subtract(20, "year").format("YYYY");
    },
    DateNaissanceFormated() {
      return this.$storeBourse.FormatDate(
        this.$storeBourse.editedItem.dateNaissance
      );
    },
    MinDateNaissance() {
      if (this.$storeBourse.DonneesFormulaireEC.dateAgeFratrie) {
        return moment(
          this.$storeBourse.DonneesFormulaireEC.dateAgeFratrie
        ).format("YYYY-MM-DD");
      }

      return "1900-01-01";
    },
    MaxDateNaissance() {
      return moment(String(new Date())).format("YYYY-MM-DD");
    },
    DateAgeFratrieFormated() {
      if (this.$storeBourse.DonneesFormulaireEC.dateAgeFratrie) {
        return moment(
          this.$storeBourse.DonneesFormulaireEC.dateAgeFratrie,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
      }

      return "01/01/1900";
    },
  },
  methods: {
    SituationHandicapChange(){
      if(this.$storeBourse.editedItem.situationHandicap === this.$storeCatalogue.DataId.Non){
        this.$storeBourse.editedItem.natureHandicap = [];
      }
    },
    ListeFratrie() {
      return this.$storeBourse.DonneesFormulaireEC.listeFratrie;
    },
    EditItem(item) {
      // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
      this.$storeBourse.editItem(
        item,
        this.$storeBourse.DonneesFormulaireEC.listeFratrie
      );

      // ouvre le popup
      this.dialog = true;
    },
    DeleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        this.$storeBourse.deleteItem(
          item,
          this.$storeBourse.DonneesFormulaireEC.listeFratrie
        );
      }
    },
    Close() {
      // RAZ des champs du formulaire
      this.$refs.form.resetValidation();

      // ferme le popup
      this.dialog = false;

      this.$storeBourse.close(this.blankItem);
    },
    Save() {
      // Vérification des doublons (nom, prénom, date de naissance)
      const doublon = this.$storeBourse.DonneesFormulaireEC.listeFratrie.some((item, index) => {
          return index !== this.$storeBourse.editedIndex && 
                  !item.supprimer &&
                  item.nom?.toLowerCase() === this.$storeBourse.editedItem.nom?.toLowerCase() &&
                  item.prenom?.toLowerCase() === this.$storeBourse.editedItem.prenom?.toLowerCase() &&
                  item.dateNaissance === this.$storeBourse.editedItem.dateNaissance;
      });

      if (doublon) {
          this.dialogDoublon.texte = "Une personne avec le même nom, prénom et date de naissance existe déjà dans la liste.";
          this.dialogDoublon.model = true;
          return;
      }

      // validation du formulaire
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }

      this.$storeBourse.save(
        this.$storeBourse.DonneesFormulaireEC.listeFratrie
      );
      // on appelle close pour raz l'item local + fermer le popup
      this.Close();
    },
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
